import { Box } from '@mui/material'

const MIN_BAND_PX = 10

export default function PeriodBands({ bands, pxPerHour, height, dayCount, column, row }) {
  if (!bands.length) return null

  return (
    <Box
      sx={{
        gridColumn: `${column} / span ${dayCount}`,
        gridRow: row,
        position: 'relative',
        height,
        zIndex: 1,
        pointerEvents: 'none',
      }}
    >
      {bands.map(band => (
        <Box
          key={band.period.id}
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: band.topHours * pxPerHour,
            height: Math.max(MIN_BAND_PX, band.heightHours * pxPerHour),
            bgcolor: 'action.hover',
            borderTop: '1px dashed',
            borderBottom: '1px dashed',
            borderColor: 'divider',
          }}
        />
      ))}
    </Box>
  )
}
